import * as React from "react";
import { Link } from "react-router-dom";
import DirectoryStore from "../../../../stores/DirectoryStore";
import { GetDirectoryList } from "../../../../actions/DirectoriesActions";
class DirectorySidebar extends React.Component {
  //isList: Array<BPModel>;
  constructor(props) {
    super(props);
    this.state = {
      dirList: [],
      searchText: "",
      filteredDirList: [],
      dirsLoaded: false,
      h: window.innerHeight - 57
    };
    this.onReceiveDirectoryChange = this.onReceiveDirectoryChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
  }
  componentDidMount() {
    DirectoryStore.addChangeListener(this.onReceiveDirectoryChange);
    GetDirectoryList();
  }
  componentWillUnmount() {
    DirectoryStore.removeChangeListener(this.onReceiveDirectoryChange);
  }
  onReceiveDirectoryChange() {
    let lastChange = DirectoryStore.lastChange();
    if (lastChange === "DirectoriesList") {
      let dirs = DirectoryStore.getDirectories();
      this.setState({
        dirList: dirs,
        searchText: "",
        filteredDirList: dirs
      });
    }
  }
  onSearchChange(e) {
    let search = e.target.value;
    if (search === "") {
      let newList = [...this.state.dirList];
      this.setState({ searchText: search, filteredDirList: newList });
    } else {
      let newList = [];
      this.state.dirList.forEach((dir) => {
        if (dir.uploadPath.toLowerCase().includes(search.toLowerCase())) {
          newList.push(dir);
        }
      });
      this.setState({ searchText: search, filteredDirList: newList });
    }
  }
  render() {
    let listOfDirs;
    if (this.state.dirList !== void 0) {
      listOfDirs = this.state.filteredDirList.map((dir) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" }, key: dir.uploadId }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/DirectoryView/" + dir.uploadId,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        dir.uploadPath
      )));
    } else {
      listOfDirs = /* @__PURE__ */ React.createElement("div", null);
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark coolScroll",
        style: { maxHeight: `${this.state.h}px`, width: "245px", overflow: "auto" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/Directories",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4 display-4" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-folder-open" }), "   ", "Directories")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { className: "input-group rounded", style: { marginBottom: "16px" } }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "search",
          value: this.state.searchText,
          className: "form-control",
          placeholder: "Search",
          "aria-label": "Search",
          onChange: this.onSearchChange,
          "aria-describedby": "search-addon"
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "input-group-text border-0", id: "search-addon" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-search" }))),
      /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "50%", overflow: "auto" } }, listOfDirs),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/DirectoryView/0" }, "New Directory")
    );
  }
}
export default DirectorySidebar;
